const HEIC_QUALITY = 0.85

export async function convertFileIfHeic(file: File): Promise<File> {
  const name = file.name.toLowerCase()
  const isHeic =
    file.type === 'image/heic' ||
    file.type === 'image/heif' ||
    name.endsWith('.heic') ||
    name.endsWith('.heif')

  if (!isHeic) {
    return file
  }

  let blob: Blob
  try {
    const bitmap = await createImageBitmap(file)
    const canvas = document.createElement('canvas')
    canvas.width = bitmap.width
    canvas.height = bitmap.height
    const ctx = canvas.getContext('2d')

    if (!ctx) {
      throw new Error('canvas 2d context unavailable')
    }
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(bitmap, 0, 0)
    bitmap.close()
    blob = await new Promise<Blob>((res, rej) =>
      canvas.toBlob(
        (b) => (b ? res(b) : rej(new Error('canvas.toBlob failed'))),
        'image/jpeg',
        HEIC_QUALITY,
      ),
    )
  } catch {
    const { heicTo } = await import('heic-to')
    blob = await heicTo({ blob: file, type: 'image/jpeg', quality: HEIC_QUALITY })
  }

  const jpegName = file.name.replace(/\.(heic|heif)$/i, '.jpg')

  return new File([blob], jpegName, { type: 'image/jpeg', lastModified: Date.now() })
}
